const { createTheme } = require("@mui/material/styles");
const defaultTheme = createTheme();

const themeConfig = {
	shape: {
		borderRadius: 0,
	},
	breakpoints: {
		values: {
			xs: 0,
			sm: 768,
			md: 1024,
			lg: 1350,
			xl: 1420,
		},
	},
	typography: {
		fontFamily: "'Source Sans 3'",
		fontWeight: 400,
		fontSize: 14,
		h1: {
			fontFamily: "'Source Serif 4'",
			fontSize: "34px",
			fontWeight: 600,
			lineHeight: "34px",
		},
		h2: {
			fontFamily: "'Source Serif 4'",
			fontSize: "2rem !important",
			fontWeight: 600,
		},
		h3: {
			fontFamily: "'Source Serif 4'",
			fontSize: "1.5rem !important",
			fontWeight: 600,
			lineHeight: "30px",
		},
		h4: {
			fontFamily: "'Source Sans 3'",
		},
		h5: {
			fontSize: "22px !important",
			fontFamily: "'Source Serif 4'",
		},
		h6: {
			fontSize: "1rem",
			fontFamily: "'Source Sans 3'",
		},
		caption: {
			fontSize: "1rem",
			fontFamily: "'Source Sans 3'",
		},
		body1: {
			fontSize: "1.15em",
			fontFamily: "'Source Sans 3'",
		},
		nav: {
			fontFamily: "'Source Sans 3'",
			fontWeight: 400,
			"&:hover, &:active, &:focus": {
				backgroundColor: "rgba(255, 255, 255, 0.5)",
				"& .label": {},
			},
		},
		toolsNav: {
			fontFamily: "'Source Sans 3'",
			fontSize: "1rem",
			textTransform: "none",
			fontWeight: 600,
		},
		brandTitle: {
			fontSize: "1.15rem",
			fontWeight: 400,
			color: "#13244E",
			fontFamily: "Jost",
			textTransform: "uppercase",
			borderBottom: "2px solid #f47a5c",
			textAlign: "center",
			paddingBottom: "6px",
			paddingLeft: "6px",
			paddingRight: "6px",
			[defaultTheme.breakpoints.down("sm")]: {
				fontSize: "0.8rem",
				borderBottomWidth: "1px",
				paddingBottom: "3px",
				paddingLeft: "3px",
				paddingRight: "3px",
			},
		},
		brandSubtitle: {
			fontSize: "0.86rem",
			fontWeight: 400,
			color: "#13244E",
			fontFamily: "Jost",
			textTransform: "none",
			textAlign: "center",
			paddingTop: "4px",
			fontStyle: "normal",
			[defaultTheme.breakpoints.down("sm")]: {
				fontSize: "0.6rem",
				paddingTop: "2px",
			},
		},
	},
	palette: {
		body: {
			lighter: "#ffffff",
			light: "#ffffff",
			main: "#F4F4F4",
			dark: "#e8e8e8",
			darker: "#dcdcdc",
			contrastText: "#686c7c",
		},
		headings: {
			main: "#002C73",
		},
		divider: "#E0E0E0",
		indigo: {
			main: "#101d42",
			light: "#101d42",
			dark: "#101d42",
			contrastText: "#fff",
		},
		link: {
			light: "#0b4099",
			main: "#002c73",
			dark: "#001d4d",
			contrastText: "#fff",
		},
		dark: {
			lighter: "#8e92a3",
			light: "#686c7c",
			main: "#101d42",
			dark: "#091126",
			darker: "#03060f",
			contrastText: "#ffffff",
		},
		footer: {
			main: "#888888",
			light: "#888888",
			dark: "#888888",
			contrastText: "#fff",
		},
		colophon: {
			main: "#444444",
			light: "#444444",
			dark: "#444444",
			contrastText: "#BDBCB9",
		},
		titleBar: {
			public: {
				light: "#000",
				main: "#000",
				dark: "#000",
				contrastText: "#fff",
			},
		},
		appBar: {
			public: {
				light: "#edf2ef",
				main: "#edf2ef",
				dark: "#c2d6cd",
				contrastText: "#000",
			},
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					backgroundColor: "#f47a5c",
					color: "#fff",
				},
				backgroundColor: "#f47a5c",
				color: "#fff",
				heading: {
					color: "#fff",
					backgroundColor: "#f47a5c",
				},
				link: {
					color: "#fff",
					backgroundColor: "#f47a5c",
				},
			},
		},
	},
	cloverleaf: {
		brand: {
			size: 64,
			logoFooterSize: 55,
			logoFooter: "/logo-footer.png",
		},
		navbar: {
			layout: "bar",
			searchOnTools: true,
			padding: 1,
			align: "left",
			labelIcons: {
				search: "Search",
				cart: "Shop",
				login: "My Profile",
				logout: "Logout",
			},
		},
		text: {
			luminance: "light",
		},
		single: {
			style: "flush",
		},
		list: {
			excerpt: {
				padding: 1.5,
			},
		},
		components: {
			More: {
				backgroundColor: "#f47a5c",
				color: "#fff",
			},
			CallToAction: {
				backgroundColor: "#f47a5c",
				color: "#fff",
			},
		},
		newsletter: false,
		googleFont:
			"Jost:wght@500&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&family=Source+Serif+4:ital,opsz,wght@0,8..60,200..900;1,8..60,200..900",
		css: `
      #___gatsby :focus, #___gatsby  a:focus, #___gatsby  button:focus {
        outline: 2px solid #f47a5c;
      }
      #___gatsby .MuiAppBar-root {
        box-shadow: none;
        border-bottom: 3px solid #f47a5c;
      }
      #___gatsby footer .footer .MuiTypography-brandTitle {
        border-bottom-color: #fff !important;
      }
      #___gatsby footer .footer .MuiTypography-brandTitle,
      #___gatsby footer .footer .MuiTypography-brandSubtitle {
        color: #fff !important;
      }
    `,
	},
};

module.exports = themeConfig;
